<template>
  <Cursorflor />
  <BtnFlotWA />
  <Navbar />
  <CartDrawer />

  <section>
    <Hero />
  </section>

  <section>
    <BrandBar />
  </section>

  <section class="sectionBestSellers" >
    <Bestsellers />
  </section>

  <section>
    <Beneficios />
  </section>

  <!--<section>
    <IGMoments />
  </section> -->

  <!-- <img class="bannerestatico" src="@/assets/banners/bannerestatico.png "> 
  <section style="padding: 0">
    <video class="bannerestatico" autoplay muted loop playsinline :alt="video" src="@/assets/banners/banner_estatico_vid.mp4 " />
  </section>-->



    <Footer />
</template>


<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Bannner from '@/components/Bannner.vue';
import Datepicker from '@vuepic/vue-datepicker'; //datepicker
import '@vuepic/vue-datepicker/dist/main.css' //datepicker
import { ref } from 'vue'; //datepicker
import '@vuepic/vue-datepicker/src/VueDatePicker/style/main.scss';
import GoogleMap from '@/components/GoogleMap.vue';
import { useI18n } from 'vue-i18n';
import Bestsellers from '@/components/Bestsellers.vue';
import Hero from '@/components/Hero.vue';
import BtnFlotWA from '@/components/BtnFlotWA.vue';
import BrandBar from '@/components/BrandBar.vue';
import Beneficios from '@/components/Beneficios.vue';
import IGMoments from '@/components/IGMoments.vue';
import Cursorflor from '@/components/Cursorflor.vue';
import CartDrawer from '@/components/CartDrawer.vue';

// import Banner_home from '@/components/Banner_home.vue'

export default {
  setup () {
    const { t } = useI18n;
    return { t };
  },
  name: 'Home',
  components: {
    Navbar, Footer, Bannner,Datepicker,GoogleMap,Hero,Bestsellers, BtnFlotWA, BrandBar, Beneficios , IGMoments,Cursorflor, CartDrawer,
  data() {
    return {
      date: null,
      language :  null,showPopup: true,

      items: [
          
        ],
    };
  },

  data: () => ({
    valid: true,
    name: '', apmaterno: '', appaterno: '',
    nameRules: [
      v => !!v || 'Dato requerido',
      v => (v && v.length <= 30) || 'No debe exceder de los caracteres',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail requerido',
      v => /.+@.+\..+/.test(v) || 'E-mail debe ser válido ',
    ],
    number: '',
    numberRules: [
      v => !!v || 'Dato requerido',
      v => ((v > 0 || v < 9)) || 'Debe ser un número',
      v => (v.length <= 6) || ' Deben ser menos de 6 digitos',
    ],

    select: null,
    items: [
      'Quejas',
      'Sugerencias',
      'Bolsa de trabajo',
    ],
    checkbox : false
  }

  ),

  methods: {
    async validate() {
      const { valid } = await this.$refs.form.validate()
      if (valid) alert('Formulario valido')
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    
  },
  created() {
    
  },
  mounted(){
    window.scrollTo(0, 0);
  }
}
}



</script>

<style>
.dp-custom-cell{
  border-radius: 50%;
  color:black;
  font-size: 1.3rem ; 
}

#imagenDebajoNav {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  top: 56px; 
}

.fancy {
  position: relative;
  white-space: nowrap;
  &:after {
    --deco-height: 0.3125em;
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(var(--deco-height) * -0.625);
    height: var(--deco-height);
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath d='M-17 30.5C-1 22 72-4 54 13 37.9 28.2-2.5 57.5 16 55.5s72-29 104-40' stroke='%2300FDCF' stroke-width='10'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h100v64H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    background-size: auto 100%;
    background-repeat: round;
    background-position: 0em;
  }
}

.bannerestatico{
  width: 100%;
}


</style>